module.exports = __webpack_public_path__ + "img/live.99dee87a.png";